import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface XuanYuanTopBarProps {
  title: string;
  onBack: () => void;
  subtitle?: string;
  right?: React.ReactNode;
  dataBackMarker?: string;
  variant?: 'gold' | 'slate' | 'light' | 'lightBlend' | 'goldOverlay';
  sticky?: boolean;
  maxWidthClassName?: string;
  paddingClassName?: string;
  containerClassName?: string;
}

const VARIANT_CLASS: Record<NonNullable<XuanYuanTopBarProps['variant']>, string> = {
  gold: 'bg-gradient-to-b from-[#9a7343] via-[#b38750] to-[#c79a61] text-white',
  goldOverlay: 'bg-transparent text-white',
  slate: 'bg-slate-900 text-white',
  light: 'bg-white/72 backdrop-blur-md border-b border-white/70 text-slate-900',
  lightBlend: 'bg-white/35 backdrop-blur-md text-slate-900',
};

const XuanYuanTopBar: React.FC<XuanYuanTopBarProps> = ({
  title,
  onBack,
  subtitle,
  right,
  dataBackMarker,
  variant = 'gold',
  sticky = true,
  maxWidthClassName = 'max-w-5xl',
  paddingClassName = 'pt-[calc(env(safe-area-inset-top,0px)+0.35rem)] pb-2.5',
  containerClassName = '',
}) => {
  const isLight = variant === 'light' || variant === 'lightBlend';
  const hoverClass = isLight ? 'hover:bg-slate-200/65' : 'hover:bg-white/15';
  const iconClass = isLight ? 'text-slate-700' : '';
  const subtitleClass = isLight ? 'text-slate-500' : 'text-white/80';

  return (
    <div
      className={`${sticky ? 'sticky top-0 z-30' : ''} ${VARIANT_CLASS[variant]} px-4 ${paddingClassName} ${containerClassName}`.trim()}
    >
      <div className={`mx-auto ${maxWidthClassName}`}>
        <div className="grid grid-cols-[auto_1fr_auto] items-center gap-2">
          <button
            onClick={onBack}
            className={`p-2 rounded-full transition-colors ${hoverClass}`}
            data-qimen-internal-back={dataBackMarker}
            aria-label="返回"
          >
            <ArrowLeft className={`w-4 h-4 sm:w-5 sm:h-5 ${iconClass}`.trim()} />
          </button>
          <h1 className="flex-1 min-w-0 px-1 text-center text-[clamp(16px,4.6vw,22px)] font-extrabold leading-tight tracking-[0.02em] break-keep whitespace-normal">
            {title}
          </h1>
          {right ? right : <div className="w-8 sm:w-9" />}
        </div>
        {subtitle ? (
          <p className={`mt-1.5 text-sm sm:text-base pl-11 ${subtitleClass}`}>
            {subtitle}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default XuanYuanTopBar;
